import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Link as RouterLink } from 'react-router-dom';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import CardActionArea from '@material-ui/core/CardActionArea';

import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles(theme => ({
    actionArea: {
        display: 'block',
        height: '100%',
        borderRadius: 16,
        transition: 'all 0.15s ease',
        '&:hover': {
            boxShadow: '0 4px 12px rgba(63, 81, 181, 0.12)',
            transform: 'translateY(-2px)'
        }
    },
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 16,
        border: '1px solid #E5E7EB',
        boxShadow: '0 1px 3px rgba(16, 24, 40, 0.06)'
    },
    content: {
        flex: 1,
        padding: theme.spacing(3)
    },
    headerRow: {
        marginBottom: theme.spacing(2)
    },
    title: {
        fontWeight: 700,
        fontSize: '1.05rem',
        color: '#111827'
    },
    number: {
        fontWeight: 700,
        color: '#111827',
        marginTop: theme.spacing(0.5)
    },
    icon: {
        width: 44,
        height: 44,
        minWidth: 44,
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(63, 81, 181, 0.1)',
        color: '#3f51b5'
    },
    bodyText: {
        color: '#6B7280'
    },
    footer: {
        padding: theme.spacing(1.5, 3),
        borderTop: '1px solid #EEF0F4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    footerLabel: {
        fontWeight: 600,
        color: '#3f51b5',
        fontSize: '0.9rem'
    },
    chevron: {
        color: '#3f51b5'
    }
}));

const TotalUsers = props => {
    const { className, data, ...rest } = props;

    const classes = useStyles();

    return (
        <CardActionArea
            component={RouterLink}
            to={'/settings/users'}
            className={classes.actionArea}>
            <Card {...rest} className={clsx(classes.root, className)}>
                <CardContent className={classes.content}>
                    <Grid
                        container
                        direction="row"
                        wrap="nowrap"
                        justify="space-between"
                        alignItems="flex-start"
                        className={classes.headerRow}>
                        <Grid item xs zeroMinWidth>
                            <Typography className={classes.title}>
                                Utilisateurs enregistrés
                            </Typography>
                            <Typography variant="h3" className={classes.number}>
                                {data.number}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <div className={classes.icon}>
                                <PersonOutlineIcon fontSize="small" />
                            </div>
                        </Grid>
                    </Grid>

                    <Typography variant="body2" className={classes.bodyText}>
                        Dernier utilisateur créé <strong>{data.last.username}</strong> en tant que{' '}
                        <strong>{data.last.profil}</strong>
                    </Typography>
                </CardContent>

                <div className={classes.footer}>
                    <Typography className={classes.footerLabel}>
                        Configurer les utilisateurs
                    </Typography>
                    <ChevronRightIcon fontSize="small" className={classes.chevron} />
                </div>
            </Card>
        </CardActionArea>
    );
};

export default TotalUsers;
